// extracted by mini-css-extract-plugin
export default {"root":"YXL7Nt870AEOR_Q1nqk3"};